import { connect } from "react-redux";
// Component
import PreviewModal from "components/CreateSurvey/PreviewModal";
// Action
import {
  setPreviewLocale,
  changePreviewItem,
  closePreviewModal
} from "redux/modules/createSurvey";

const mapStateToProps = state => ({
  previewModal: state.createSurvey.previewModal,
  baseInfo: state.createSurvey.baseInfo,
  baseWord: state.createSurvey.baseWord,
  additions: state.createSurvey.additions
});

const mapDispatchToProps = dispatch => ({
  changeLocale: (event, localeNo) => {
    dispatch(setPreviewLocale(localeNo));
  },
  handlePrev: () => {
    dispatch(changePreviewItem(-1));
  },
  handleNext: () => {
    dispatch(changePreviewItem(1));
  },
  // 閉じる
  handleClose: () => dispatch(closePreviewModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviewModal);



// WEBPACK FOOTER //
// ./src/containers/CreateSurvey/PreviewModalContainer.js